import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`crea-personale`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
